<!--end::Header Logo-->
<div class="d-flex align-items-stretch me-3 menu-header">
    <!--begin::Header Logo-->
    <div class="header-logo">
        <a href="javascript:void(0)" style="margin-left: 25px; margin-right: 15px">
            <img alt="Logo" src="../../../../../assets/media/logos/{{ JA }}" class="logo-sticky max-h-60px" />
        </a>
    </div>
    <!--end::Header Logo-->

    <ng-container *ngIf="headerMenuSelfDisplay" class="mobile_menu">
        <!--begin::Header Menu Mobile Toggle-->
        <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
            <span></span>
        </button>
        <!--end::Header Menu Mobile Toggle-->
    </ng-container>

    <ng-container>
        <!--begin::Header Menu Wrapper-->
        <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            <!--begin::Header Menu-->
            <!-- Don't change id => 'kt_header_menu' -->
            <ng-container>
                <!-- STATIC MENU -->
                <div #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile" [ngClass]="headerMenuCSSClasses">
                    <ul class="menu-nav" [ngClass]="ulCSSClasses">
                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="../home" [routerLinkActive]="['active']">
                                <span class="menu-text">
                                    <i class="fas fa-home"></i>
                                    <!-- Home -->
                                    {{ 'INFORMATE_HEADER.Home' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <!-- begin::1 Level -->
                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isStandardFlange">
                            <a
                                class="menu-link"
                                routerLink="/informate/standardflange/false"
                                [routerLinkActive]="['active']"
                                [class.active]="router.url.startsWith('/informate/standardflange')"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <span class="menu-text">
                                    <!-- Standard Flange -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.STANDARD_FLANGE' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>
                        <!-- end::1 Level -->

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isCustomFlange">
                            <a
                                class="menu-link"
                                routerLink="/informate/customflange/false"
                                [routerLinkActive]="['active']"
                                [class.active]="router.url.startsWith('/informate/customflange')"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <span class="menu-text">
                                    <!-- Custom Flange -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CUSTOM_FLANGE' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isClamp">
                            <a
                                class="menu-link"
                                routerLink="/informate/clamp/false"
                                [routerLinkActive]="['active']"
                                [class.active]="router.url.startsWith('/informate/clamp')"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <span class="menu-text">
                                    <!-- Clamp -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CLAMP' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isEngineeredJointVisible">
                            <a
                                class="menu-link"
                                routerLink="/informate/engineeredjoint/false"
                                [routerLinkActive]="['active']"
                                [class.active]="router.url.startsWith('/informate/engineeredjoint')"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <span class="menu-text">
                                    <!-- Engineered Joint -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ENGINEERED_JOINT' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isMatrixVisible">
                            <a class="menu-link" routerLink="/informate/matrix" [routerLinkActive]="['active']">
                                <span class="menu-text">
                                    <!-- Matrix -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.MATRIX' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isIceDatabaseVisible">
                            <a class="menu-link" routerLink="/informate/icedatabase" [routerLinkActive]="['active']">
                                <span class="menu-text">
                                    <!-- Ice Database -->
                                    {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ICE_DATABASE' | transloco }}
                                </span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>
                    </ul>
                </div>
            </ng-container>

            <!--end::Header Menu-->
        </div>
        <!--end::Header Menu Wrapper-->
    </ng-container>
</div>
